import React from 'react';
import PropTypes from 'prop-types';

const ImageThumbnail = ({
  handle, width, height, alt, output = '',
}) => {
  if (!handle) return null;

  return (
    <img
      src={`https://cdn.filestackcontent.com/${output}resize=width:${width},height:${height}/${handle}`}
      alt={alt}
    />
  );
};

ImageThumbnail.propTypes = {
  handle: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  alt: PropTypes.string,
  output: PropTypes.string,
};

ImageThumbnail.defaultProps = {
  width: 92,
  height: 92,
  alt: 'image thumbnail',
  output: '',
};

export default ImageThumbnail;
